import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('poweroceanapp');

    return (
        <div className={`ef-app-pc-g ${css.efAppPCG}`}>
            <NextImage
                webpSrc={require('@publicLocal/power-ocean/app/pc/7-1.webp')}
                src={require('@publicLocal/power-ocean/app/pc/7-1.jpg')}
                alt={t('sec7_title')}
                aria-label={t('sec7_title')}
            />
            <div className="text-wrapper">
                <p className="sub-title">{t('sec7_subtitle')}</p>
                <p className="title">{t('sec7_title')}</p>
                <div className="panel">
                    <div className="left">
                        <p className="title-g">{t('sec7_title2')}</p>
                        <p className="desc-g">{t('sec7_desc2')}</p>
                    </div>
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/7-2.webp')}
                        src={require('@publicLocal/power-ocean/app/7-2.png')}
                        alt={t('sec7_title')}
                        aria-label={t('sec7_title')}
                    />
                </div>
            </div>
        </div>
    );
}
